(() => {
    angular
        .module('app')
        .controller('clinic.views.patient.previewTicket', PreviewTicketPageController);

    PreviewTicketPageController.$inject = [
        '$scope',
        '$state',
        '$stateParams',
        '$sce',
        '$filter',
        'abp.services.app.patientTicket',
        'abp.services.app.commonLookup',
        'moment',
        'Hms.PatientTickets.TreatmentType',
        '$window',
        'Hms.Services.ServiceType',
    ];

    function PreviewTicketPageController(
        $scope,
        $state,
        $stateParams,
        $sce,
        $filter,
        patientTicketSvc,
        commonLookupSvc,
        moment,
        enumPatientTicketTreatmentType,
        $window,
        enumServiceType
    ) {
        const unitValueFilter = $filter('unitValue');
        const frequencyUnitValueFilter = $filter('frequencyUnitValue');

        const vm = this;
        vm.loading = 0;
        vm.isClinic = App.isClinic();
        vm.isHost = App.isHost();
        vm.saving = 0;
        vm.isUpdated = false;
        vm.employeeId = $stateParams.employeeId;
        vm.clinicLocationId = $stateParams.clinicLocationId;
        vm.ticketType = $stateParams.ticketType;
        vm.patientSessionId = $stateParams.ticketType;
        vm.serviceType = $stateParams.serviceType;
        vm.isLateSubmission = $stateParams.patientSessionId > 0;
        vm.lateSubmissionReason = $stateParams.lateSubmissionReason;
        vm.lateSubmissionRequestorName = $stateParams.lateSubmissionRequestorName;

        vm.hasRegionalSystemSupport = abp.setting.getBoolean(
            'Hms.Feature.RegionalSystemSupport'
        );
        vm.hasGpTicketEnhancement = abp.setting.getBoolean(
            'Hms.Feature.GPTicketEnhancement'
        );
        vm.hasMyForeignerConsultationSstExemption = abp.setting.getBoolean(
            'Hms.Feature.MyForeignerConsultationSstExemption'
        );

        vm.enums = {};
        vm.enums.patientTicketTreatmentTypes = enumPatientTicketTreatmentType;
        vm.enums.serviceTypes = enumServiceType;
        vm.treatmentTypes = vm.enums.patientTicketTreatmentTypes.values;

        function init() {
            getTenantCurrencyCode();
            getTicket();

            // To resolve race condition

            setTimeout(() => {
                $scope.$broadcast('prescriptionTicket');
            }, 1000);
        }

        function getTicket() {
            vm.loading += 1;
            patientTicketSvc.getPanelTicketForEdit({
                employeeId: $stateParams.employeeId,
                ticketNumber: $stateParams.ticketNumber,
                clinicLocationId: $stateParams.clinicLocationId,
                clinicType: $stateParams.clinicType,
                ticketType: $stateParams.ticketType,
                claimId: $stateParams.claimId,
                serviceType: $stateParams.serviceType
            }).success((data) => {
                vm.doctors = data.doctors || [];
                vm.patient = data.patient;
                vm.clinic = data.clinic || {};
                vm.treatments = data.treatments || [];
                vm.symptoms = data.symptom || [];
                vm.ticketNumber = data.ticket.ticketNumber;
                vm.employeeId = data.patient.id;
                vm.ticketDate = moment(data.ticket.ticketDate);
                vm.ticket = data.ticket;
                vm.countryCode = data.countryCode;

                // Get tax type.

                vm.tax = data.taxDetails;

                // Prefill with draft if any.

                if (data.ticketDraft) {
                    const draft = JSON.parse(data.ticketDraft);
                    vm.ticket = draft;
                }

                vm.hasTax = vm.ticket.taxCode != null && vm.ticket.taxPercentage != null && vm.ticket.taxPercentage > 0;

                vm.showForeignerSST = vm.patient
                    && vm.patient.isForeignPatient
                    && vm.countryCode === 'MY'
                    && vm.hasGpTicketEnhancement;

                if (vm.isLateSubmission) {
                    vm.validateLateSubmission();
                }

                vm.treatmentData = [];

                if (vm.ticket.consultation) {
                    const consultationTreatment = _.find(vm.treatments, (q) => q.displayName === 'Consultation');

                    const symptoms = _.join(vm.ticket.consultation.symptoms, ', ');
                    const prescriptions = [];
                    prescriptions.push(
                        setManualPrescription(symptoms, vm.ticket.consultation.amount)
                    );

                    if (vm.ticket.referralLetter) {
                        prescriptions.push(
                            setManualPrescription(
                                App.localize('ReferralLetter'),
                                vm.ticket.referralLetter.amount
                            )
                        );
                    }

                    vm.treatmentData.push({
                        treatmentName: consultationTreatment.displayName,
                        prescriptions
                    });
                }

                _.each(vm.ticket.treatments, (treatment) => {
                    if (vm.ticket.serviceType === vm.enums.serviceTypes.HealthScreening.id) {
                        vm.treatmentData.push(treatment);
                    }
                    else if (treatment.treatment) {
                        const result = _.chain(treatment.prescriptions)
                            .filter('drugId')
                            .map((k) => ({
                                productName: k.name,
                                quantity: unitValueFilter(k.quantity),
                                amount: k.amount,
                                strength: k.strength ? k.strength.value : null,
                                strengthUnit: k.strength ? k.strength.unit : null,
                                dosage: getDosageAsString(k.dosage, k.dosageFrequency),
                                treatmentType: k.treatmentType
                            }))
                            .value();

                        vm.treatmentData.push({
                            treatmentName: treatment.treatment.displayName,
                            prescriptions: result
                        });
                    }
                });

                vm.pharmacyLocationName = '';
                vm.pharmacyTreatments = [];
                if (vm.ticket.pharmacyPrescription
                    && vm.ticket.pharmacyPrescription.issue !== false) {
                    _.forEach(vm.ticket.pharmacyPrescription.treatments, (treatment) => {
                        if (treatment.treatment) {
                            const result = _.chain(treatment.prescriptions)
                                .filter('drugId')
                                .map((k) => ({
                                    productName: k.name,
                                    quantity: unitValueFilter(k.quantity),
                                    amount: k.amount,
                                    strength: k.strength ? k.strength.value : null,
                                    strengthUnit: k.strength ? k.strength.unit : null,
                                    dosage: getDosageAsString(k.dosage, k.dosageFrequency)
                                }))
                                .value();

                            vm.pharmacyTreatments.push({
                                treatmentName: treatment.treatment.displayName,
                                prescriptions: result
                            });
                        }
                    });

                    const location = _.find(data.pharmacyLocations,
                        { value: vm.ticket.pharmacyPrescription.pharmacyLocationId });
                    if (location) vm.pharmacyLocationName = location.name;
                }

                vm.doctor = _.find(vm.doctors, (s) => s.id === vm.ticket.doctorId);

                if (vm.ticket.medicalCertificate) {
                    vm.ticket.medicalCertificate.startDate =
                        moment(vm.ticket.medicalCertificate.startDate);
                    vm.ticket.medicalCertificate.endDate =
                        moment(vm.ticket.medicalCertificate.endDate);
                    vm.ticket.checkedInTime = moment(vm.ticket.checkedInTime);
                    vm.isMcStartDateAlsoCheckedInDate = vm.ticket.medicalCertificate.startDate.diff(vm.ticket.checkedInTime.startOf('days'), 'days') === 0;
                }
            }).error(() => {
                $window.history.back();
            }).finally(() => {
                vm.loading -= 1;
            });
        }

        function setManualPrescription(prescriptionName, amount) {
            return {
                productName: prescriptionName,
                dosage: '-',
                quantity: '-',
                amount
            };
        }

        vm.validateLateSubmission = validateLateSubmission;
        function validateLateSubmission() {
            if (typeof $stateParams.requestorName === 'undefined'
                || typeof $stateParams.reason === 'undefined'
                || $stateParams.requestorName === null
                || $stateParams.reason === null) {
                abp.message.error(App.localize('MissingLateSubmissionInformation'));
                $state.go('clinic.panelDashboard');
            }
        };

        vm.getMcNarrative = getMcNarrative;
        function getMcNarrative() {
            if (vm.ticket.medicalCertificate) {
                const patientName = `<strong>${vm.patient.name}</strong>`;
                const corporateName = `<strong>${vm.patient.corporate.name}</strong>`;
                const startDate = moment(vm.ticket.medicalCertificate.startDate).format('L');
                const endDate = moment(vm.ticket.medicalCertificate.endDate).format('L');
                return $sce.trustAsHtml(App.localize('McNarrative',
                    patientName,
                    corporateName,
                    vm.getMcDuration(),
                    startDate,
                    endDate)
                );
            }

            return '';
        };

        vm.getMcDuration = getMcDuration;
        function getMcDuration() {
            if (vm.ticket.medicalCertificate) {
                const startDate = moment(vm.ticket.medicalCertificate.startDate);
                const endDate = moment(vm.ticket.medicalCertificate.endDate);
                const duration = endDate.diff(startDate, 'days') + 1;
                return duration;
            }
            return '';
        };

        vm.getSubtotalAmount = getSubtotalAmount;
        function getSubtotalAmount() {
            let amount = 0;
            if (vm.ticket) {
                _.each(vm.ticket.treatments, (t) => {
                    _.each(t.prescriptions, (p) => {
                        if (t.treatment && p.amount) {
                            amount += p.amount;
                        }
                    });
                });
                if (vm.ticket.consultation)
                    amount += vm.ticket.consultation.amount;
                if (vm.ticket.referralLetter)
                    amount += vm.ticket.referralLetter.amount;
            }
            if (vm.hasTax && vm.ticket.isTaxInclusive) {
                const exempt = getConsultationExemptAmount();
                return exempt + (amount - exempt) / (1 + vm.ticket.taxPercentage / 100);
            }

            return amount;
        };

        // The JKDM non-citizen rule exempts the doctor's consultation fee from SST.
        // Mirrors the backend gate: a MY foreign patient on a GP/Dental ticket, with the flag on.
        function isConsultationSstExempt() {
            return vm.hasMyForeignerConsultationSstExemption === true
                && vm.showForeignerSST === true;
        }

        // The part of the bill that carries no tax. Zero unless the exemption applies,
        // so every tax figure below stays exactly as it was before the feature.
        function getConsultationExemptAmount() {
            if (!isConsultationSstExempt()) return 0;
            if (!vm.ticket || !vm.ticket.consultation) return 0;
            return vm.ticket.consultation.amount || 0;
        }

        vm.getTaxAmount = getTaxAmount;
        function getTaxAmount() {
            const exempt = getConsultationExemptAmount();

            if (vm.hasTax && vm.ticket && vm.ticket.treatments && !vm.ticket.isTaxInclusive)
                return (vm.getSubtotalAmount() - exempt) * (vm.ticket.taxPercentage / 100);

            if (vm.hasTax && vm.ticket && vm.ticket.treatments && vm.ticket.isTaxInclusive) {
                const taxable = vm.getSubtotalAmount() - exempt;
                return taxable * (1 + vm.ticket.taxPercentage / 100) - taxable;
            }

            return 0;
        }

        vm.getTotalAmount = getTotalAmount;
        function getTotalAmount() {
            if (vm.ticket && vm.ticket.treatments) {
                return vm.hasTax
                    ? vm.getSubtotalAmount() + vm.getTaxAmount()
                    : vm.getSubtotalAmount();
            }

            return 0;
        };

        vm.calculateAmountCoverage = calculateAmountCoverage;
        function calculateAmountCoverage() {
            let claimable = 0;
            let total = 0;
            let uncovered = 0;
            let coPay = 0;
            let exceeded = 0
            let collectCash = 0;

            // Consultation fee carved out of the taxable base when the JKDM exemption applies.
            // Tracked per bucket: the consultation can sit on either side of the split.
            let exemptClaimable = 0;
            let exemptUncovered = 0;

            if (vm.ticket) {
                _.each(vm.ticket.treatments, (t) => {
                    if (vm.ticket.serviceType === vm.enums.serviceTypes.HealthScreening.id) {
                        if (!t.isUncovered) {
                            claimable += t.amount || 0;
                        } else {
                            uncovered += t.amount || 0;
                        }
                        total += t.amount || 0;
                    } else if (t && t.prescriptions) {
                        _.each(t.prescriptions, (p) => {
                            const rate = p.amount;
                            if (t.treatment && rate) {
                                if (!t.treatment.notCovered) {
                                    claimable += rate;
                                }
                                else {
                                    uncovered += rate;
                                }
                                total += rate;
                            }
                        });
                    }
                });

                if (vm.ticket.consultation) {
                    const consultationAmount = vm.ticket.consultation.amount;
                    const consultationTreatment = _.find(vm.treatments, (q) => q.displayName === 'Consultation');
                    if (!consultationTreatment.notCovered) {
                        claimable += consultationAmount;
                    } else {
                        uncovered += consultationAmount;
                    }

                    if (isConsultationSstExempt()) {
                        if (!consultationTreatment.notCovered) {
                            exemptClaimable += consultationAmount;
                        } else {
                            exemptUncovered += consultationAmount;
                        }
                    }

                    total += consultationAmount;

                    if (vm.ticket.referralLetter) {
                        if (!consultationTreatment.notCovered) {
                            claimable += vm.ticket.referralLetter.amount;
                        } else {
                            uncovered += vm.ticket.referralLetter.amount;
                        }

                        total += vm.ticket.referralLetter.amount;
                    }
                }
            }

            // Add tax to total and claimable amount.

            if (vm.hasTax && vm.ticket.taxPercentage && !vm.ticket.isTaxInclusive) {
                // An exempt consultation still counts towards amounts, not the tax base.
                const taxableTotal = total - exemptClaimable - exemptUncovered;
                const taxableClaimable = claimable - exemptClaimable;
                const taxableUncovered = uncovered - exemptUncovered;

                total += App.roundAmount(taxableTotal * vm.ticket.taxPercentage / 100);
                claimable += App.roundAmount(taxableClaimable * vm.ticket.taxPercentage / 100);
                uncovered += App.roundAmount(taxableUncovered * (vm.ticket.taxPercentage / 100));
            }

            // NOTE: Co-payment is now based on covered amount.
            // More info: HM-4333.
            // Calculation for co-payment: covered amount * co-pay percentage.

            if (vm.patient && vm.ticket) {
                // Apply co-pay for normal/reimbursement tickets.

                if (claimable) {
                    if (vm.patient.coPay) {
                        coPay = vm.patient.coPay.value;

                        // Calculate new co-pay amount.

                        if (vm.patient.coPay.isPercentage) {
                            coPay *= claimable / 100;
                        } else {
                            coPay = Math.min(claimable, coPay);
                        }
                    }
                }
                exceeded = Math.max(claimable - coPay - vm.patient.allowance, 0);
                collectCash = coPay + uncovered + exceeded;
            }

            // Round number to 2 decimal places.

            total = App.roundAmount(total);
            collectCash = App.roundAmount(collectCash);
            coPay = App.roundAmount(coPay);
            exceeded = App.roundAmount(exceeded);
            collectCash = App.roundAmount(collectCash);

            return {
                claimable: App.roundAmount(total - collectCash),
                manualPayment: collectCash,
                uncovered,
                exceeded,
                copay: coPay
            };
        };

        vm.getManualPaymentAmount = getManualPaymentAmount;
        function getManualPaymentAmount() {
            return vm.calculateAmountCoverage().manualPayment;
        };

        vm.getCoveredAmount = getCoveredAmount;
        function getCoveredAmount() {
            return vm.calculateAmountCoverage().claimable;
        };

        vm.getUncoveredAmount = getUncoveredAmount;
        function getUncoveredAmount() {
            return vm.calculateAmountCoverage().uncovered;
        };

        vm.getExceededAmount = getExceededAmount;
        function getExceededAmount() {
            return vm.calculateAmountCoverage().exceeded;
        };

        vm.getCoPayAmount = getCoPayAmount;
        function getCoPayAmount() {
            return vm.calculateAmountCoverage().copay;
        };

        vm.submitTicket = submitTicket;
        function submitTicket() {
            if (vm.saving !== 0) return;
            vm.saving += 1;

            let treatments = null;

            if (vm.ticket.serviceType === vm.enums.serviceTypes.HealthScreening.id) {
                treatments = vm.ticket.treatments;
            } else {
                treatments = _.chain(vm.ticket.treatments)
                    .filter('treatmentId')
                    .map((t) => ({
                        treatmentId: t.treatmentId,
                        prescriptions: _.chain(t.prescriptions)
                            .filter('drugId')
                            .map((p) => p.drugId > 0 ? p
                                : _.extend({}, p, { drugId: null }))
                            .value()
                    }))
                    .value()
            }
            
            const attachments = [];
            if (vm.ticket.serviceType === vm.enums.serviceTypes.HealthScreening.id) {
                _.each(vm.ticket.attachments, (attachment) => {
                    if (!attachment.isDelete) attachments.push(attachment.id);
                });
            }

            const input = {
                doctorId: vm.ticket.doctorId,
                treatments,
                manualPayment: vm.getManualPaymentAmount(),
                clinicLocationId: vm.clinicLocationId,
                medicalCertificate: vm.ticket.medicalCertificate,
                referralLetter: vm.ticket.referralLetter,
                clinicType: vm.ticket.clinicType,
                ticketDate: vm.ticketDate,
                ticketType: vm.ticket.ticketType,
                attachments,
                newAttachments: [],
                consultation: vm.ticket.consultation,
                symptoms: vm.ticket.symptoms,
                preTaxAmount: vm.hasTax ? vm.getSubtotalAmount() : vm.getTotalAmount(),
                requestId: vm.ticket.requestId,
                isTaxInclusive: vm.ticket.isTaxInclusive
            };

            if (vm.ticket.pharmacyPrescription && vm.ticket.pharmacyPrescription.issue !== false) {
                input.pharmacyPrescription = _.extend({}, vm.ticket.pharmacyPrescription);
                input.pharmacyPrescription.treatments =
                    _.chain(input.pharmacyPrescription.treatments)
                        .filter('treatmentId')
                        .map((t) => ({
                            treatmentId: t.treatmentId,
                            prescriptions: _.chain(t.prescriptions)
                                .filter('drugId')
                                .map((p) => p.drugId > 0 ? p
                                    : _.extend({}, p, { drugId: null }))
                                .value()
                        }))
                        .value();
            }

            patientTicketSvc.createTicketForPanel($.extend(input, {
                employeeId: vm.employeeId
            })).success((data) => {
                abp.notify.info(App.localize('TicketXIssued', data.ticketNumber));
                vm.isUpdated = true;

                $state.go('clinic.patientTicketSubmited', {
                    ticketNumber: data.ticketNumber,
                    hasMc: vm.ticket.medicalCertificate !== null,
                    cashAmount: vm.getManualPaymentAmount(),
                    subsidiaryName: vm.patient.corporate.subsidiaryName,
                    hasPrescription: vm.ticket.pharmacyPrescription
                        && vm.ticket.pharmacyPrescription.issue !== false
                });
            }).finally(() => {
                vm.saving -= 1;
            });
        };

        function getDosageAsString(dosage, dosageFrequency) {
            let tokens = [unitValueFilter(dosage), frequencyUnitValueFilter(dosageFrequency)];
            tokens = _.filter(tokens, (t) => t);

            if (tokens.length) return tokens.join(', ');
            return '-';
        }

        function getTenantCurrencyCode() {
            vm.loading += 1;
            commonLookupSvc.getTenantCurrencyCode()
                .success((data) => {
                    vm.currencyCode = data;
                }).finally(() => {
                    vm.loading -= 1;
                })
        }

        init();
    }
})();
